import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsEnhancedTripResponse } from "../../Orchestrator/Types/Interface/ICmsEnhancedTrip";

export async function getCmsEnhanceTrips(): Promise<
    IApiResponse<ICmsEnhancedTripResponse>
> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getEnhanceYourTripAPI;

    const params = new URLSearchParams({
        "populate": "image",
        locale: await getLocaleFromCookie()
    });

    let endpointWithParams = `${endpoint}?${params.toString()}`;
    return await cmsApiRequest<ICmsEnhancedTripResponse>(endpointWithParams, "GET");
}
